import Config from './config.json'
import getSDKURL from './sdkHost'
import appendScript from './jsscript'
import appendStyle from './style'

let widgetsJsIsReady = false
let widgetReadyCallbackCalled = false

window.APWWidget = {
  onReady(widgetReadyCallback) {
    this.widgetReadyCallback = widgetReadyCallback

    if (!widgetReadyCallbackCalled && widgetsJsIsReady) {
      widgetReadyCallback(window[Config.widgetGlobalName])
      widgetReadyCallbackCalled = true
    }
  },
}

const widgetScriptReadyCallback = () => {
  const { widgetReadyCallback } = window.APWWidget
  widgetsJsIsReady = true

  if (widgetReadyCallback && !widgetReadyCallbackCalled) {
    widgetReadyCallback(window[Config.widgetGlobalName])
    widgetReadyCallbackCalled = true
  }
}

const { passportPathUrl } = getSDKURL()
// eslint-disable-next-line no-undef
passportPathUrl.searchParams.append('v', RESOURCE_VERSION)
appendScript(passportPathUrl.href, () => {
  window.uiCacheAppUrl = window.APWWidget.uiCacheAppUrl // eslint-disable-line
  window.uiCacheWidgetUrl = window.APWWidget.uiCacheWidgetUrl // eslint-disable-line
  window.passportAPIServerHost = window.APWWidget.passportUrl // eslint-disable-line
  window.keycloakAPIServerHost = window.APWWidget.keycloakUrl // eslint-disable-line

  // eslint-disable-next-line no-undef
  appendScript(`${window.uiCacheWidgetUrl}/Widgets.min.js?v=${RESOURCE_VERSION}`, widgetScriptReadyCallback)
  // eslint-disable-next-line no-undef
  appendStyle(`${window.uiCacheWidgetUrl}/Widgets.min.css?v=${RESOURCE_VERSION}`)
})
